<template>
  <v-dialog max-width="900" v-model="dialog" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        class="green lighten-4 green--text text--darken-4 font-weight-bold"
        rounded
        depressed
        height="30"
        >Selecionar pedidos</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">Selecionar pedidos</v-card-title>
      <v-card-subtitle
        >Pedidos liberados para formação de carga</v-card-subtitle
      >
      <v-card-text>
        <pedidos-liberados-form-carga />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          rounded
          @click="dialog = false"
          :block="isMobile()"
          text
          :class="{ secondary: isMobile() }"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PedidosLiberadosFormCarga from "./PedidosLiberadosFormCarga.vue";
export default {
  components: { PedidosLiberadosFormCarga },
  data: () => ({
    dialog: false,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>